import { useState } from 'react';
import Section from './Section';

const FAQS = [
  {
    q: '必吃大瓜每天几点更新？',
    a: '必吃大瓜坚持每日滚动更新。今日重磅与全量吃瓜流会在每天早间与傍晚分两波上线，本周必看每周一整理，本月最劲爆月初复盘，年度盘点专题则从年末开始陆续放送。建议把首页加入收藏，每天点开都有新瓜。',
  },
  {
    q: '如何理解“今日重磅、本周必看、本月最劲爆”的区别？',
    a: '它们按时间颗粒度划分：今日重磅收录当天传播最快、讨论最集中的事件；本周必看由编辑部每周挑选最值得回味的几条；本月最劲爆则是本月话题度与传播度的月度榜单。同一件事可能横跨多个周期，代表它的热度足够持久。',
  },
  {
    q: '内容来源可靠吗？为什么还要我自己去核实？',
    a: '必吃大瓜的内容由编辑部基于公开信息与多方信源整理撰写，我们优先引用官方口径并标注来源。但互联网信息真假难辨，遇到反转事件我们也会第一时间跟进更正，也强烈建议你参考官方信源进行二次确认，理性吃瓜。',
  },
  {
    q: '遇到疑似造谣或AI合成内容，我可以举报吗？',
    a: '可以。你可以在对应平台使用“一键举报疑似AI内容”入口，也可以把线索与链接发送到编辑部邮箱 bichidagua@example.com。我们核实后会及时在站内标注或辟谣，共同维护清朗的吃瓜环境。',
  },
  {
    q: '我有独家线索，如何投稿？',
    a: '欢迎通过页面底部的“投稿线索”入口或邮箱联系我们。请尽量提供时间、地点、可核实的信息或素材链接。必吃大瓜会对信源严格保密，并在发布前完成必要的核实流程，拒绝未经证实的片面之词。',
  },
  {
    q: '这里的“年度盘点”和普通热榜有什么不同？',
    a: '年度盘点不是简单的流量排行，而是编辑部结合事件影响力、行业意义与观众记忆点，对全年内容做的综合梳理。每一条都会附上入选理由与复盘脉络，帮助你在一年的喧嚣中留下真正值得回味的时刻。',
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQS.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <Section
      id="faq"
      icon="ri-question-answer-line"
      title="吃瓜百科 · 常见问题"
      en="FREQUENTLY ASKED QUESTIONS"
      desc="关于必吃大瓜的内容机制、信息核实与投稿方式，你想知道的都在这里。理性吃瓜，从读透规则开始。"
    >
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="mx-auto max-w-3xl space-y-3">
        {FAQS.map((f, i) => {
          const active = open === i;
          return (
            <div
              key={i}
              className={`overflow-hidden rounded-xl border transition ${
                active ? 'border-primary-300 bg-primary-50/40' : 'border-background-200 bg-background-50'
              }`}
            >
              <button
                type="button"
                onClick={() => setOpen(active ? -1 : i)}
                className="flex w-full items-center gap-3 px-5 py-4 text-left"
                aria-expanded={active}
              >
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-foreground-950 text-xs font-bold text-accent-400">
                  Q
                </span>
                <h3 className="flex-1 text-[15px] font-bold text-foreground-900 md:text-base">{f.q}</h3>
                <i
                  className={`shrink-0 text-xl text-foreground-400 transition ${
                    active ? 'rotate-180 text-primary-500' : ''
                  } ri-add-line`}
                />
              </button>
              {active && (
                <div className="px-5 pb-5">
                  <div className="ml-10 border-l-2 border-accent-300 pl-4">
                    <p className="text-sm leading-7 text-foreground-700">{f.a}</p>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </Section>
  );
}